import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { AppConfig } from "../constants";
import { TranslateLoader, TranslateModule, TranslateService } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { AppRoutingModule } from "./app-routing.module";
import { APP_BASE_HREF } from "@angular/common";
import { environment } from '../environments/environment';
import {FormsModule} from "@angular/forms";
import {AgmCoreModule} from "@agm/core";
import {MapComponent} from './map/map.component';
import {DirectionsMapDirective} from "./map/map-directions.directive";
import {GeoLocationService} from "./services/geoLocation.service";
import {GoogleMapsService} from "./services/googleMaps.service";
import {EnumKeysPipe} from './pipes/enumKeys.pipe';
import { PointsListComponent } from './points-list/points-list.component';
import {TranslatedPipe} from "./pipes/translated.pipe";
import {PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface, PerfectScrollbarModule} from "ngx-perfect-scrollbar";
import { PointDetailsComponent } from './point-details/point-details.component';
import {FacebookModule} from "ng2-facebook-sdk";
import { LoginPage } from './login-page/login.page';
import {AuthGuard} from "./guards/auth.guard";
import { DirectionDetailsComponent } from './direction-details/direction-details.component';
import { CategoryIconComponent } from './category-icon/category-icon.component';
import {TitleCasePipe} from "./pipes/titleCase.pipe";
import { AppControlsComponent } from './app-controls/app-controls.component';
import {RegularCasePipe} from "./pipes/regularText.pipe";
import {AngularFireModule} from "angularfire2";
import {AngularFirestoreModule} from "angularfire2/firestore";
import {AngularFireAuthModule} from "angularfire2/auth";
import {AngularFireStorageModule} from "angularfire2/storage";
import {OrderModule} from "ngx-order-pipe";
import {TripsListComponent} from "./trips-list/trips-list.component";
import { UserAvatarComponent } from './user-avatar/user-avatar.component';
import {MomentPipe} from "./pipes/moment.pipe";
import {DistancePipe} from "./pipes/distance.pipe";

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

@NgModule({
  declarations: [
    AppComponent,
    MapComponent,
    DirectionsMapDirective,
    MomentPipe,
    EnumKeysPipe,
    DistancePipe,
    TranslatedPipe,
    TitleCasePipe,
    RegularCasePipe,
    PointsListComponent,
    PointDetailsComponent,
    TripsListComponent,
    LoginPage,
    DirectionDetailsComponent,
    CategoryIconComponent,
    AppControlsComponent,
    UserAvatarComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    OrderModule,
    PerfectScrollbarModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule, // imports firebase/firestore, only needed for database features
    AngularFireAuthModule, // imports firebase/auth, only needed for auth features,
    // AngularFireStorageModule // imports firebase/storage only needed for storage features
    FacebookModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    AppRoutingModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBWTA2U-f1aR6s102Qk8AlAlpkl5bI5tjc',
      libraries: ["geometry"] // places
    })
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    AuthGuard,
    GeoLocationService,
    GoogleMapsService,
    { provide: LOCALE_ID, useValue: AppConfig.locale },
    { provide: APP_BASE_HREF, useValue: environment.baseHref },
    { provide: 'GoogleMapsApiKey', useValue: 'AIzaSyBWTA2U-f1aR6s102Qk8AlAlpkl5bI5tjc' },
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Development/Private Projects/random-ride/RandomRide/src/app/app.module.ts